import {useState} from 'react'
import clsx from 'clsx'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faDesktop, faMoon, faSun} from '@fortawesome/free-solid-svg-icons'
import {ThemeModeType, useThemeMode} from './ThemeModeProvider'

type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
  menuPlacement?: string
  menuTrigger?: string
}

const themeOptions: {mode: ThemeModeType; label: string; icon: typeof faSun}[] = [
  {mode: 'light', label: 'Light Mode', icon: faSun},
  {mode: 'dark', label: 'Dark Mode', icon: faMoon},
  {mode: 'system', label: 'System Mode', icon: faDesktop},
]

const ThemeModeSwitcher = ({toggleBtnClass = ''}: Props) => {
  const {mode, systemMode, updateMode} = useThemeMode()
  const [isOpen, setIsOpen] = useState(false)
  const resolvedMode = mode === 'system' ? systemMode : mode
  const activeOption = themeOptions.find((option) => option.mode === mode) || themeOptions[0]

  const selectMode = (nextMode: ThemeModeType) => {
    updateMode(nextMode)
    setIsOpen(false)
  }

  return (
    <div className='position-relative'>
      <button
        type='button'
        className={clsx(toggleBtnClass || 'btn btn-icon btn-active-light-primary')}
        aria-label={`Theme: ${activeOption.label}`}
        aria-haspopup='menu'
        aria-expanded={isOpen}
        title={activeOption.label}
        onClick={() => setIsOpen((open) => !open)}
      >
        <FontAwesomeIcon icon={resolvedMode === 'dark' ? faMoon : faSun} />
      </button>
      {isOpen && (
        <div
          className='dropdown-menu dropdown-menu-end show'
          role='menu'
          style={{position: 'absolute', top: '100%', right: 0, zIndex: 1070, minWidth: '180px'}}
        >
          {themeOptions.map((option) => (
            <button
              key={option.mode}
              type='button'
              role='menuitemradio'
              aria-checked={mode === option.mode}
              className={clsx('dropdown-item d-flex align-items-center gap-3', {
                active: mode === option.mode,
              })}
              onClick={() => selectMode(option.mode)}
            >
              <FontAwesomeIcon icon={option.icon} className='w-15px' />
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export {ThemeModeSwitcher}
